import * as React from "react";
import {observer} from "mobx-react-lite";
import {
    CBox,
    CDrawer,
    CList,
    CListItemButton,
    CListItemIcon,
    CListItemText
} from "../components";
import {Route, Routes, useLocation, useMatch, useNavigate} from "react-router-dom";
import {
    ChevronLeft,
    ChevronRight,
    DashboardOutlined,
    LogoutOutlined,
    MouseOutlined,
    PeopleOutline, SettingsOutlined, StartOutlined
} from "@mui/icons-material";
import {CSSObject, Theme, useTheme} from "@mui/material";
import {Actions, Projects, Onboarding, Settings, Staff} from "../screens";
import {useStores} from "../models";

export const PanelNavigator = observer(
    function PanelNavigator() {

        const [open, setOpen] = React.useState(true);

        const {authStore} = useStores()
        const {logout} = authStore

        const match = useMatch("/panel/*");
        const url = match?.pathnameBase
        const routeMatch = useMatch("*");
        const routeUrl = routeMatch?.pathnameBase
        const theme = useTheme();
        const navigate = useNavigate();
        const location = useLocation();


        // let isDashboardOpen = location.pathname.includes("panel/dashboard");
        // let isClaimsPageOpen = location.pathname.includes("panel/claims");
        // let isPaymentsPageOpen = location.pathname.includes("panel/payments");

        const openedMixin = (theme: Theme): CSSObject => ({
            width: 320,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            overflowX: 'hidden',
        });

        const closedMixin = (theme: Theme): CSSObject => ({
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: 'hidden',
            width: `calc(${theme.spacing(7)} + 3px)`,
            [theme.breakpoints.up('sm')]: {
                width: `calc(${theme.spacing(8)} + 3px)`,
            },
        });


        return (
            <>
                <CBox style={{minHeight: '100vh', display: 'flex', padding: 12}}>
                    <CDrawer variant="permanent"

                             sx={{
                                 ...(open && {
                                     ...openedMixin(theme)
                                 }),
                                 ...(!open && {
                                     ...closedMixin(theme)
                                 }),
                                 mr: 2
                             }}
                             PaperProps={{
                        sx: {
                            margin: '12px',
                            boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
                            borderRadius: '37px',
                            borderWidth: 0,
                            ...(open && {
                                ...openedMixin(theme)
                            }),
                            ...(!open && {
                                ...closedMixin(theme)
                            }),
                        }
                    }}>
                        <CList>
                            <CListItemButton
                                key={"Chev"}
                                onClick={() => setOpen(!open)}
                                sx={{
                                    m: 1,
                                    borderRadius: 4,
                                }}
                            >
                                <CListItemIcon sx={{color: theme => theme.palette.primary.light}}>
                                    {open ? <ChevronLeft/> : <ChevronRight/>}
                                </CListItemIcon>
                            </CListItemButton>
                            <CListItemButton
                                key={"Projects"}
                                onClick={() => navigate(`${url}/projects`)}
                                selected={location.pathname === `${url}/projects`}
                                sx={{
                                    m: 1,
                                    borderRadius: 4,
                                }}
                            >
                                <CListItemIcon sx={{color: theme => theme.palette.primary.light}}>
                                    <DashboardOutlined/>
                                </CListItemIcon>
                                <CListItemText
                                    primary={open ? "Projects" : "|"}
                                    sx={{
                                        color: theme => theme.palette.primary.light,
                                        opacity: open ? 1 : 0,
                                    }}
                                />
                            </CListItemButton>
                            {/*<CListItemButton*/}
                            {/*    key={"Settings"}*/}
                            {/*    onClick={() => navigate(`${url}/settings`)}*/}
                            {/*    selected={location.pathname === `${url}/settings`}*/}
                            {/*    sx={{*/}
                            {/*        m: 1,*/}
                            {/*        borderRadius: 4,*/}
                            {/*    }}*/}
                            {/*>*/}
                            {/*    <CListItemIcon sx={{color: theme => theme.palette.primary.light}}>*/}
                            {/*        <SettingsOutlined/>*/}
                            {/*    </CListItemIcon>*/}
                            {/*    <CListItemText*/}
                            {/*        primary={open ? "Settings" : "|"}*/}
                            {/*        sx={{*/}
                            {/*            color: theme => theme.palette.primary.light,*/}
                            {/*            opacity: open ? 1 : 0,*/}
                            {/*        }}*/}
                            {/*    />*/}
                            {/*</CListItemButton>*/}
                            {/*<CListItemButton*/}
                            {/*    key={"Onboarding"}*/}
                            {/*    onClick={() => navigate(`${url}/onboarding`)}*/}
                            {/*    selected={location.pathname === `${url}/onboarding`}*/}
                            {/*    sx={{*/}
                            {/*        m: 1,*/}
                            {/*        borderRadius: 4,*/}
                            {/*    }}*/}
                            {/*>*/}
                            {/*    <CListItemIcon sx={{color: theme => theme.palette.primary.light}}>*/}
                            {/*        <StartOutlined/>*/}
                            {/*    </CListItemIcon>*/}
                            {/*    <CListItemText*/}
                            {/*        primary={open ? "Onboarding" : "|"}*/}
                            {/*        sx={{*/}
                            {/*            color: theme => theme.palette.primary.light,*/}
                            {/*            opacity: open ? 1 : 0,*/}
                            {/*        }}*/}
                            {/*    />*/}
                            {/*</CListItemButton>*/}
                            <CListItemButton
                                key={"Actions"}
                                onClick={() => navigate(`${url}/actions`)}
                                selected={location.pathname === `${url}/actions`}
                                sx={{
                                    m: 1,
                                    borderRadius: 4,
                                }}
                            >
                                <CListItemIcon sx={{color: theme => theme.palette.primary.light}}>
                                    <MouseOutlined/>
                                </CListItemIcon>
                                <CListItemText
                                    primary={open ? "Actions" : "|"}
                                    sx={{
                                        color: theme => theme.palette.primary.light,
                                        opacity: open ? 1 : 0,
                                    }}
                                />
                            </CListItemButton>
                            {authStore.staff?.role === "owner" && <CListItemButton
                                key={"Staff"}
                                onClick={() => navigate(`${url}/staff`)}
                                selected={location.pathname === `${url}/staff`}
                                sx={{
                                    m: 1,
                                    borderRadius: 4,
                                }}
                            >
                                <CListItemIcon sx={{color: theme => theme.palette.primary.light}}>
                                    <PeopleOutline/>
                                </CListItemIcon>
                                <CListItemText
                                    primary={open ? "Staff" : "|"}
                                    sx={{
                                        color: theme => theme.palette.primary.light,
                                        opacity: open ? 1 : 0,
                                    }}
                                />
                            </CListItemButton>}
                            <CListItemButton
                                key={"Logout"}
                                onClick={() => {
                                    logout()
                                    navigate(`/login`)
                                }}
                                sx={{
                                    m: 1,
                                    borderRadius: 4,
                                }}
                            >
                                <CListItemIcon sx={{color: theme => theme.palette.primary.light}}>
                                    <LogoutOutlined/>
                                </CListItemIcon>
                                <CListItemText
                                    primary={open ? "Logout" : "|"}
                                    sx={{
                                        color: theme => theme.palette.primary.light,
                                        opacity: open ? 1 : 0,
                                    }}
                                />
                            </CListItemButton>
                        </CList>

                    </CDrawer>
                    <CBox component={'main'} style={{flexGrow: 1}}>
                        <Routes>
                            <Route path={`${routeUrl}/projects`} element={<Projects/>}/>
                            <Route path={`${routeUrl}/actions`} element={<Actions/>}/>
                            {authStore.staff?.role === "owner" && <Route path={`${routeUrl}/staff`} element={<Staff/>}/>}
                        </Routes>
                    </CBox>

                </CBox>
            </>
        );
    }
)
